export const STREET_ALIASES = {
  st: "street",
  rd: "road",
  ave: "avenue",
  av: "avenue",
  cres: "crescent",
  dr: "drive",
  hwy: "highway",
  ln: "lane",
  pl: "place",
  ct: "court",
  ter: "terrace",
  mt: "mount"
} as const;

export type StreetAlias = keyof typeof STREET_ALIASES;
export type CanonicalStreetAlias = (typeof STREET_ALIASES)[StreetAlias];

export function isStreetAlias(token: string): token is StreetAlias {
  return Object.prototype.hasOwnProperty.call(STREET_ALIASES, token);
}
